var map = {
	"./bebidas.jpg": "349e",
	"./burritos.jpg": "154b",
	"./especiales.jpg": "6ee7",
	"./mgp.jpg": "8e35",
	"./otros.jpg": "07f5",
	"./profile-pic.jpg": "71a2",
	"./tacos.jpg": "bc84"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710a";